<script setup lang="ts">
import { onMounted } from 'vue'

const visible = defineModel<boolean>()

const props = defineProps({
  serviceId: {
    type: String,
    default: ''
  }
})

onMounted(() => {})

const emit = defineEmits(['finish'])

function handleSetting(play: boolean) {
  console.log('handleSetting:', props.serviceId, play)
  emit('finish', props.serviceId, play)
  visible.value = false
}
</script>
<template>
  <el-dialog v-model="visible" :show-close="false" class="w-78 h-72 px-2">
    <template #header="{ titleId }">
      <div relative w-full flex="~ col" items-center>
        <div :id="titleId" grow text-xl leading-8 mt-2 px-4 text-theme-dark>{{ $t('music.play_setting.title') }}</div>
        <button btn-theme-solid mt-8 class="py-2.6 px-4 w-40" @click="handleSetting(true)">
          {{ $t('music.play_setting.play_music') }}
        </button>
        <button btn-theme-outline mt-6 class="py-2.2 px-4 w-40 rounded-2" @click="handleSetting(false)">
          {{ $t('music.play_setting.not_play') }}
        </button>
      </div>
    </template>
  </el-dialog>
</template>
<style lang="scss" scoped></style>
